
    <th>

    </th>
    <th>
        <a class="table-header-link"
           (click)="refresh(1,'PriceAdjustments.active','ASC')">Aktiv robot</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.active' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.active' && filter.direction==='ASC'"></i>
    </th>
    <th>
        <a class="table-header-link"
           (click)="refresh(1,'is_active','ASC')">Aktiv web</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'is_active' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'is_active' && filter.direction==='ASC'"></i>
    </th>
    <th>Varenummer</th>
    <th>Produkt</th>
    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'UsedPrice.price','DESC')">IDA pris</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'UsedPrice.price' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'UsedPrice.price' && filter.direction==='ASC'"></i>
    </th>
    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.price','DESC')">Justeret pris</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.price' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.price' && filter.direction==='ASC'"></i>
    </th>

    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.shipping_cost','DESC')">Fragt</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.shipping_cost' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.shipping_cost' && filter.direction==='ASC'"></i>
    </th>

    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.costprice_2','DESC')">K2 incl. moms</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.costprice_2' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.costprice_2' && filter.direction==='ASC'"></i>
    </th>

    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.minium_margin','DESC')">Min. DG</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.minium_margin' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.minium_margin' && filter.direction==='ASC'"></i>
    </th>

    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.minimum_price','DESC')">Min. pris</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.minimum_price' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.minimum_price' && filter.direction==='ASC'"></i>
    </th>

    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'crawler_urls_count','DESC')">Konkurrenter</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'crawler_urls_count' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'crawler_urls_count' && filter.direction==='ASC'"></i>
    </th>
    <th>
        Billigste aktør
    </th>
    <th>
        Salgsenhed
    </th>
    <th><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.competitor_diff','DESC')">Prisstatus</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.competitor_diff' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.competitor_diff' && filter.direction==='ASC'"></i>
    </th>

    <th class="text-end"><a
            class="table-header-link"
            (click)="refresh(1,'PriceAdjustments.deviation_pct','DESC')" [ngbTooltip]="'Hvor mange % er 10-4 for dyrere el. billigere end billigste konkurrent'">Prisafvigelse</a>
        <i class="ms-1 far fa-arrow-alt-circle-down"
           *ngIf="filter.sort === 'PriceAdjustments.deviation_pct' && filter.direction==='DESC'"></i>
        <i class="ms-1 far fa-arrow-alt-circle-up"
           *ngIf="filter.sort === 'PriceAdjustments.deviation_pct' && filter.direction==='ASC'"></i>
    </th>

    <th>Producent</th>
    <th>Ansvarlige bruger</th>
